/* Copyright (c) 2024 Xperi. All Rights Reserved. */

// using release build
const shaka = require('shaka-player/shaka-player.compiled');

export class ShakaPlayerUtils {
    private static TAG: string = 'ShakaPlayerUtils';

    private static ERROR_CONVERSION_CONSTANT = 1000;

    public static getHttpErrorCode(error: any): string {
        if (error.code === shaka.util.Error.Code.LICENSE_REQUEST_FAILED) {
            const httpCode: string =
                error.data[0] && error.data[0].data[1] ? `${error.data[0].data[1]}` : '';
            if (httpCode === '401' || httpCode === '403') return httpCode;
        }
        return '';
    }

    public static getSubErrorCode(error: any): string {
        const httpCode = ShakaPlayerUtils.getHttpErrorCode(error);
        if (httpCode) return httpCode;
        return (error.code % ShakaPlayerUtils.ERROR_CONVERSION_CONSTANT)
            .toString()
            .padStart(3, '0');
    }

    public static isErrorHandlingRequired(error: any): boolean {
        let isError = true;

        // Load can be interrupted by unload or another load
        if (error?.code === shaka.util.Error.Code.LOAD_INTERRUPTED) {
            isError = false;
        }
        return isError;
    }

    public static isRetryableError(error: any) {
        const errorCode = error.code;
        const errorCategory = error.category;
        let isRetryable: boolean = false;
        switch (errorCategory) {
            case shaka.util.Error.Category.ADS:
            case shaka.util.Error.Category.CAST:
            case shaka.util.Error.Category.MANIFEST:
            case shaka.util.Error.Category.NETWORK:
            case shaka.util.Error.Category.STORAGE:
            case shaka.util.Error.Category.STREAMING:
                isRetryable = false;
                break;
            case shaka.util.Error.Category.DRM:
                if (ShakaPlayerUtils.getHttpErrorCode(error)) isRetryable = false;
                else if (
                    errorCode === shaka.util.Error.Code.LICENSE_REQUEST_FAILED ||
                    errorCode === shaka.util.Error.Code.LICENSE_RESPONSE_REJECTED
                )
                    isRetryable = true;
                break;
            case shaka.util.Error.Category.MEDIA:
            case shaka.util.Error.Category.TEXT:
                isRetryable = true;
                break;
            case shaka.util.Error.Category.PLAYER:
                if (
                    errorCode === shaka.util.Error.Code.LOAD_INTERRUPTED ||
                    errorCode === shaka.util.Error.Code.OPERATION_ABORTED ||
                    errorCode === shaka.util.Error.Code.CONTENT_NOT_LOADED
                )
                    isRetryable = true;
                break;
            default:
                isRetryable = true;
                break;
        }
        return isRetryable;
    }

    public static isShakaNetworkError(error: any): boolean {
        return error.category === shaka.util.Error.Category.NETWORK;
    }
}
